module.exports = __webpack_public_path__ + "static/media/RobotoCondensed-Bold.cbd4e701.ttf";